import {
  Route, Switch, useRouteMatch,
} from 'react-router-dom';
import Home from '../pages/cms/pages/home';

export default function Routes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/cms/pages/home`} component={Home} />
    </Switch>
  );
}
